<se-fe-modal-button [seFeDataButton]="{icon: true}" (seFeButtonAction)="orgModal.open($event)">
  <se-fe-icon
    seFeModalIcon
    seFeDataName="pencil_fill"
    seFeDataSize="500"
    seFeDataColor="default"
    seFeDataAriaLabel="edit"></se-fe-icon>
</se-fe-modal-button>

<se-fe-modal
  seFeDataSize="large"
  #orgModal
  [seFeDataActions]="orgModalButtons"
  (seFeBeforeOpen)="onBeforeOpen()"
  (seFeClose)="resetForm()">
  <div seFeModalHeader>
    <se-fe-modal-header
      [seFeDataTitle]="'Edit Product organization'"
      (seFeButtonAction)="orgModal.close()"></se-fe-modal-header>
  </div>

  <se-fe-modal-content>
    <form [formGroup]="form" novalidate>
      <se-fe-grid seFeGridOpts="snug">
        <se-fe-grid-cell seFeGridOpts>
          <se-fe-form-field class="modal-form-field brand" [seFeDataConfig]="productBrandConfig">
            <se-fe-form-field-text
              formControlName="brand"
              seFeDataAutoComplete="off"
              [seFeDataReadOnly]="catalogsOnly()"></se-fe-form-field-text>
          </se-fe-form-field>
          <se-fe-form-field class="modal-form-field" [seFeDataConfig]="productVendorConfig" tabindex="-1">
            <se-fe-form-field-text
              #vendorName
              class="vendor-name"
              formControlName="vendorName"
              seFeDataAutoComplete="off"
              tabindex="-1"
              [seFeDataReadOnly]="true"></se-fe-form-field-text>
          </se-fe-form-field>
          <se-fe-form-control-help class="media-help">
            You can't change this because your organization is the seller of this product
          </se-fe-form-control-help>
          @if (!catalogsOnly()) {
            <se-fe-form-field class="modal-form-field tax-code" [seFeDataConfig]="productTaxCodeConfig">
              <se-fe-form-field-text formControlName="taxCode" seFeDataAutoComplete="off"></se-fe-form-field-text>
            </se-fe-form-field>
            <se-fe-form-control-help class="media-help">
              Enter the
              <a href="https://www.ungm.org/public/unspsc" target="_blank" rel="noopener noreferrer">UNSPSC code</a>
              to collect sales tax for this product
            </se-fe-form-control-help>
          }
          <se-fe-form-field class="modal-form-field" [seFeDataConfig]="productCatalogsConfig"></se-fe-form-field>
          @if (catalogsLoading()) {
            <se-fe-spinner [seFeDataCenter]="true"></se-fe-spinner>
          } @else {
            <se-fe-form-field-multiselect
              formControlName="catalogIds"
              [seFeDataOptions]="catalogOptions()"
              seFeDataPlaceholder="Select"
              seFeDataPosition="bottom"
              [seFeDataComfy]="true"></se-fe-form-field-multiselect>
          }
          <se-fe-form-control-help class="media-help">
            Catalogs allow you to specify where you sell your products
          </se-fe-form-control-help>
          @if (error()) {
            <se-fe-alert seFeDataType="error">
              {{ error() }}
            </se-fe-alert>
          }
        </se-fe-grid-cell>
      </se-fe-grid>
    </form>
  </se-fe-modal-content>
</se-fe-modal>
